import { reactive, toRefs } from '@vue/composition-api';
import { userSendConfirmCode, userSendReceivedCode } from '@/js/repositories/User';

import { SMS_RESENDING_TIMEOUT } from '@/js/helpers/globalConst';

const useSmsConfirm = (props, { emit }) => {
  const params = reactive({
    value: '',
    isMaySendAnotherCode: false,
    timeLeft: 0,
    errorSendReceivedCode: '',
    isSendingCode: false,
    countdown: null,
    isFetchingCode: false,
  });

  const sendReceivedCodeMethod = async () => {
    params.isSendingCode = true;
    params.errorSendReceivedCode = '';
    try {
      await userSendReceivedCode({ phone: props.phone, confirmCode: params.value });
      emit('verified');
    } catch (e) {
      params.errorSendReceivedCode = e.message;
    } finally {
      params.isSendingCode = false;
    }
  };

  const sendCode = async () => {
    params.isFetchingCode = true;

    userSendConfirmCode({ phoneNumber: props.phone })
      .then(() => {
        params.timeLeft = SMS_RESENDING_TIMEOUT;
        params.countdown.abort();
        params.isMaySendAnotherCode = false;

        setTimeout(() => {
          params.countdown.start();
        }, 0);
      })
      .catch(() => {
        params.countdown.abort();
        params.timeLeft = 0;
        params.isMaySendAnotherCode = false;

        setTimeout(() => {
          params.countdown.start();
        }, 0);
      })
      .finally(() => {
        params.isFetchingCode = false;
      });
  };

  return {
    ...toRefs(params),
    sendReceivedCodeMethod,
    sendCode,
  };
};

export default useSmsConfirm;
